import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "layoutType", "className", "title", "backgroundColor", "selectedCategory", "onCategorySelect", "categories", "footer"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { useUncontrolledProp } from 'uncontrollable';
import { CardProduct } from '@sbercloud/uikit-product-site-cards';
import { Grid } from '@sbercloud/uikit-product-site-grid';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { Tabs } from '@snack-uikit/tabs';
import { SectionCatalogFooter } from '../../helperComponents';
import { SectionBasic } from '../SectionBasic';
import { GRID_CONFIG } from './constants';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SectionCatalog(_ref) {
  var id = _ref.id,
    layoutType = _ref.layoutType,
    className = _ref.className,
    title = _ref.title,
    backgroundColor = _ref.backgroundColor,
    selectedCategoryProp = _ref.selectedCategory,
    onCategorySelect = _ref.onCategorySelect,
    categories = _ref.categories,
    footer = _ref.footer,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useUncontrolledProp = useUncontrolledProp(selectedCategoryProp, categories[0].id, onCategorySelect),
    _useUncontrolledProp2 = _slicedToArray(_useUncontrolledProp, 2),
    selectedCategory = _useUncontrolledProp2[0],
    setSelectedCategory = _useUncontrolledProp2[1];
  var isDesktop = ['desktop', 'desktopSmall'].includes(layoutType);
  var isOutlineCard = backgroundColor === 'neutral-background1-level';
  return /*#__PURE__*/_jsx(SectionBasic, _objectSpread(_objectSpread({
    id: id,
    title: title,
    backgroundColor: backgroundColor,
    layoutType: layoutType,
    className: cn(className, styles.sectionCatalog)
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.body,
      children: [/*#__PURE__*/_jsxs(Tabs, {
        value: selectedCategory,
        onChange: setSelectedCategory,
        children: [/*#__PURE__*/_jsxs("div", {
          className: cn(styles.categoryList, _defineProperty({}, styles.desktopCategoryList, isDesktop)),
          children: [/*#__PURE__*/_jsx(Tabs.TabBar, {
            type: "primary",
            orientation: isDesktop ? 'vertical' : 'horizontal',
            markerPosition: isDesktop ? 'before' : 'after',
            className: cn(_defineProperty({}, styles.desktopTabs, isDesktop)),
            children: categories.map(function (_ref2) {
              var id = _ref2.id,
                label = _ref2.label;
              return /*#__PURE__*/_jsx(Tabs.Tab, {
                value: id,
                label: label
              }, id);
            })
          }), footer && isDesktop && /*#__PURE__*/_jsx(SectionCatalogFooter, {
            items: footer,
            layoutType: layoutType
          })]
        }), categories.map(function (_ref3) {
          var id = _ref3.id,
            items = _ref3.items;
          return /*#__PURE__*/_jsx(Tabs.TabContent, {
            value: id,
            className: styles.tabContent,
            children: /*#__PURE__*/_jsx(Grid, {
              columnsConfig: GRID_CONFIG,
              gap: "s",
              layoutType: layoutType,
              children: items.map(function (item) {
                return /*#__PURE__*/_jsx(CardProduct, _objectSpread({
                  layoutType: layoutType,
                  outline: isOutlineCard
                }, item), item.title);
              })
            })
          }, id);
        })]
      }), footer && !isDesktop && /*#__PURE__*/_jsx(SectionCatalogFooter, {
        items: footer,
        layoutType: layoutType
      })]
    })
  }));
}